import { escapeRegExp } from "@/lib/util";

/**
 * Highlights the text with the query.
 * Wraps matched text parts with an html <mark> tag.
 * TODO: similar component - src/gui-client/src/modules/pg/tools/management/MarkedText
 */
export function HighlightedText({ text, query }: { text: string; query: string }) {
    if (!text.trim() || !query.trim()) return <>{text}</>;

    const tokens: string[] = query.trim().split(/\s+/).filter(Boolean);

    // Example: query: "set batch" -> tokens: ['set', 'batch']
    const pattern = tokens.map(token => escapeRegExp(token)).join("|");
    const regex = new RegExp(`(${pattern})`, "gi");
    const parts = String(text).split(regex);

    // Wraps every other (odd-indexed) part with a mark tag.
    // Example
    //  - for query: 'operation'
    //    parts:['ERP defines start and end time for ', 'operation', ' that is used in simulation.']
    //  - for query: 'set batch'
    //    parts: ['Plan import: ', 'set', ' ', 'batch', '']
    return <>{parts.map((part, index) => (index % 2 === 1 ? <mark key={index}>{part}</mark> : part))}</>;
}
